<template>
  <section class="book-visit-form">
    <h2>
      Book Inter-{{ 'prison' | term(true) }} Call
    </h2>
    <router-link :to="{ name: 'calls' }" class="body-text">
      &laquo; Back to video calls
    </router-link>
    <div class="row mt-3">
      <div class="col-sm-6">
        <b-card>
          <b-alert class="p-1" variant="warning" :show="latestBookingDate !== null">The {{ 'prison' | term(true) }} has a latest
            booking date, therefore no dates will show for booking slots after {{ latestBookingDate | formatDate }}
          </b-alert>

          <div class="form-group">
            <label class="control-label">{{ 'prisoner' | term(true) }} Number</label>
            <div class="input-group">
              <b-form-input @input="setVuexProp($event, 'prisonerNumber', true)"
                            @keyup.enter="searchForContacts()"
                            :value="prisonerNumber"/>
              <div class="input-group-append">
                <button
                  class="btn btn-primary"
                  v-on:click="searchForContacts"
                >
                  Search
                </button>
              </div>
            </div>
          </div>

          <div class="form-group" v-if="wingEnabled">
            <label class="control-label">Wing</label>
            <select
              :disabled="loadingWings"
              class="form-control"
              v-model="selectedWing"
              v-on:change="selectWing()"
            >
              <option v-for="(wing, idx) in wings" :key="idx" :value="wing">
                {{ wing.name }}
              </option>
            </select>
          </div>
          <div class="form-group">
            <label class="control-label">Inter-Prison Contact</label>
            <b-form-select
              :disabled="loadingContacts || !prisonerNumber"
              class="form-control"
              :value="visitor"
              v-on:change="selectVisitor($event)"
            >
              <option v-for="(contact, idx) in contacts" :key="idx" :value="contact">{{ contact.user.firstname }}
                {{ contact.user.lastname }} is my {{ contact.relationship.toLowerCase() }} at
                {{ contact.user.offsite_name }}
              </option>
            </b-form-select>
            <p class="mt-1 d-flex align-items-center" :class="{'disabled': !prisonerNumber}">Contact not showing?
              <b-btn @click="addNewContact(2)" class="btn py-0" variant="link">Add new Contact</b-btn>
            </p>
          </div>
          <div class="form-group">
            <label class="control-label">Inter-Prison Contact Email <small>(who to notify that a call has been
              booked)</small></label>
            <b-form-input
              :disabled="loadingContacts || !prisonerNumber"
              class="form-control"
              :value="bookingEmail"
              @input="$store.commit('booking/SET_BOOKING_EMAIL', $event)"
            />
          </div>
          <div class="form-group" v-if="!adHocMode">
            <label class="control-label d-flex justify-content-between align-items-center">
              Booking Slot <b-btn @click="setAdhocMode(true)" class="btn py-0" variant="link">Use Ad-hoc Slot</b-btn>
            </label>
            <b-form-select
              class="form-control"
              value="selectedBookingSlotId"
              :disabled="wingEnabled ? !selectedWing : false"
              v-on:change="setBookingSlotId($event)">
              <optgroup v-for="(groupedSlot, index) in bookingSlotsGrouped" :key="index"
                        :label="groupedSlot.day_of_week">
                <option v-for="slot in groupedSlot.slots" :key="slot.booking_slot_id" :value="slot.booking_slot_id">
                  {{ slot.name }} {{ slot.slot_begin }} - {{ slot.slot_end }}
                </option>
              </optgroup>
            </b-form-select>
          </div>
          <div class="form-group" v-if="adHocMode">
            <b-btn @click="setAdhocMode(false)" class="btn py-2 px-0 full-width text-right" variant="link">Select existing slot</b-btn>
            <offsite-adhoc-slot></offsite-adhoc-slot>
          </div>
          <div class="form-group" v-if="!adHocMode">
            <label class="control-label">Booking Date</label>
            <b-form-select class="form-control" :value="selectedBookingSlotDate" :disabled="!selectedBookingSlotId"
                    @change="getVisitsHad">
              <option v-for="(date, index) in bookingSlotDates" :key="index" :value="date.date"
                      :disabled="date.remaining === 0">{{ date.date | formatDate }} ({{ date.remaining }} Terminals
                Available)
              </option>
            </b-form-select>
          </div>

          <div>
            <p>Available Fund Tokens: <b>{{ fundTokens }}</b></p>
          </div>

          <div class="row">
            <div class="col-12">
              <div class="form-group">
                <b-form-checkbox v-model="recordVisit" switch cy="record-call">
                  Record video call
                </b-form-checkbox>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-12">
              <div class="form-group">
                <label class="control-label">Adult Content Setting</label>
                <select v-model="adultContentSettings" class="form-control" cy="adult-content">
                  <option value="Off">Off</option>
                  <option value="Alert">Alert</option>
                  <option value="Pause">Pause</option>
                </select>
                <small v-if="adultContentSettings === 'Off'">Adult content detection will be turned off and no action taken by the system.</small>
                <small v-if="adultContentSettings === 'Alert'">The master terminal will be informed of any adult content that is detected. It will be up to the staff member to take action.</small>
                <small v-if="adultContentSettings === 'Pause'">The system will automatically pause the call and warn the contact.</small>
              </div>
            </div>
          </div>

          <div v-if="isUserBannedOnBookingSlot()">
            <p class="red">
              Unable to book for that slot as the visitor is banned on that date.
            </p>
          </div>

          <div v-if="!loadingVisitsHadOnMonth && showVisitsHad()">
            <p>
              Resident has had <b>{{ visitsHadThisMonth }}</b> visits that month so far.
              <span
                v-if="checkForAllowedVisitsPerMonth">Residents are usually allowed a limit of <b>{{
                  allowedVisitsPerMonth
                }}</b> video calls a month.</span>
            </p>
          </div>

          <div class="mt-2" :class="{'disabled': bookingVisit}">
            <b-btn variant="success"
              :disabled="!isBookValid() || !validFundTokens() && !loadingSelectedVisitorBans"
              v-on:click="bookAndFundVisit()"
            >
              Book and Fund (This will use 1 of your fund tokens)
            </b-btn>
          </div>
        </b-card>
        <b-card v-if="selectedVisitorId">
          <!-- Bans -->
          <visitor-bans
            :editable="false"
            :visitor_user_id="selectedVisitorId"
          />
        </b-card>
      </div>
      <div class="col-sm-6" v-if="selectedVisitorId">
        <div class="row">
          <div class="col-12">
            <visitor-details :show-update-establishment="true" @updated="refreshContact()"
                             :visitor_user_id="selectedVisitorId"/>
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <visitors-previous-visits
              :visitor_user_id="selectedVisitorId"
              :prisoner_number="prisonerNumber"
            />
          </div>
        </div>
      </div>
    </div>

    <b-modal id="modal-contacts" ref="modal-contacts" hide-footer hide-header size="lg" :clickToClose="false">
      <offsite-contacts @contact="selectVisitor($event)" @close="closeModals()"></offsite-contacts>
    </b-modal>
  </section>
</template>

<script>
import {mapState} from 'vuex';
import BookingSlotService from '@/services/BookingSlotService';
import ContactService from '@/services/ContactService';
import VisitService from '@/services/VisitService';
import PrisonService from '@/services/PrisonService';
import VisitorService from '@/services/VisitorService';
import WingService from '@/services/WingService';
import moment from 'moment';
import VisitorsPreviousVisits from '@/views/visitorDetails/VisitorsPreviousVisits';
import VisitorDetails from '@/components/visitors/details/VisitorDetails.vue';
import {logger} from '@/util/logger';
import VisitorBans from '../../views/bans/VisitorBans';
import {getDateOfYearDayAndTime} from '@/util/helpers';
import {ERROR_CODES} from '@/util/errorCodes';
import OffsiteContacts from '@/components/bookVisit/offsiteVisit/OffsiteContacts';
import OffsiteAdhocSlot from '@/components/bookVisit/offsiteVisit/OffsiteAdhocSlot';

export default {
  name: 'book-visit-offsite',
  components: {
    VisitorDetails,
    VisitorsPreviousVisits,
    VisitorBans,
    OffsiteContacts,
    OffsiteAdhocSlot,
  },
  props: {
    wingEnabled: {
      type: Boolean,
      required: true
    }
  },
  computed: {
    ...mapState({
      prisonerNumber: state => state.booking.offsiteBooking.prisonerNumber,
      contacts: state => state.booking.contacts,
      visitor: state => state.booking.visitor,
      bookingEmail: state => state.booking.bookingEmail,
      prison: state => state.prison.prison,
      selectedBookingSlotDate: state => state.booking.selectedBookingSlotDate,
      selectedBookingSlotId: state => state.booking.selectedBookingSlotId,
      endDateValid: state => state.booking.endDateValid,
      establishments: state => state.booking.offsiteEstablishments,
    }),
  },
  beforeDestroy() {
    this.resetVisitor();
    this.setVuexProp('', 'prisonerNumber');
  },
  watch: {
    visitor: {
      deep: true,
      handler() {
        this.selectedVisitorId = this.visitor ? this.visitor.user.user_id : '';
        this.$store.dispatch('booking/setBookingEmailToEstablishments');
      }
    },
  },
  data() {
    return {
      fundTokens: '-',
      wings: [],
      selectedWing: null,
      loadingWings: true,
      securityBand: 'Off',
      adultContentSettings: 'Alert',
      invalidFaceEventAction: 'Pause',
      selectedVisitorId: '',
      loadingContacts: true,
      bookingSlotsWithStock: [],
      bookingSlotDates: [],
      bookingSlotsGrouped: [],
      loadingSelectedVisitorBans: false,
      selectedVisitorBans: [],
      checkForAllowedVisitsPerMonth: false,
      allowedVisitsPerMonth: 2,
      loadingVisitsHadOnMonth: true,
      visitsHadThisMonth: 0,
      bookingVisit: false,
      latestBookingDate: null,
      recordVisit: false,
      adHocMode: false,
      visitorEstablishment: null,
    };
  },
  mounted() {
    this.$store.dispatch('booking/refreshSites');
    this.getPrisonInfo();
    this.getFundTokens();
    if (this.wingEnabled) {
      this.fetchWings();
    } else {
      this.getBookingSlotsWithStockForWing();  // Get stock
    }
  },
  methods: {
    setAdhocMode(value) {
      this.adHocMode = value;

      if(!value) { // if false, reset
        this.setBookingSlotDate(null);
        this.setBookingSlotId(null);
        this.$store.commit('booking/SET_ADHOC_SLOT', null);
      }
    },
    setVuexProp(e, prop, uppercase = false) {
      const value = uppercase ? e.toUpperCase() : e;
      this.$store.commit('booking/SET_OFFSITE_BOOKING_ITEM', {prop, value: value});
    },
    setBookingSlotDate(e) {
      this.$store.commit('booking/SET_SELECTED_BOOKING_SLOT_DATE', e);
    },
    setBookingSlotId(e) {
      this.$store.commit('booking/SET_SELECTED_BOOKING_SLOT_ID', e);
      this.clearDateSelection();
    },
    getPrisonInfo() {
      this.allowedVisitsPerMonth = this.prison.allowed_visits_per_month;
      this.checkForAllowedVisitsPerMonth = this.prison.check_for_allowed_visits_per_month;
      this.latestBookingDate = null;
      if (this.prison.latest_booking_date) {
        this.latestBookingDate = moment(this.prison.latest_booking_date).subtract(1, 'day').toDate();
      }
      this.recordVisit = this.prison.default_call_recording;
      this.adultContentSettings = this.prison.adult_content_settings || 'Alert';
    },
    getFundTokens() {
      PrisonService.getFundTokens().then(({data}) => {
        this.fundTokens = data.tokens;
      }).catch(err => {
        logger.error(`Error getting ${this.$options.filters.term('prison')} info`, err, null, 'RequestedVisitDetails:getAvailableFundTokens');
        this.$toast.error('Something went wrong getting your fund tokens', {
          toastClassName: ['toast-std', 'warning-toast'],
        });
      });
    },
    fetchWings() {
      WingService.getWings().then(res => {
        this.wings = res.data.filter((wing) => wing.status === 'Enabled');

        this.wings = this.wings.sort((a, b) => { // sort alphabetically
          return a.name.localeCompare(b.name);
        });

        this.loadingWings = false;
      }).catch(err => {
        logger.error('Error loading wings', err, null, 'BookVisitWithWing:fetchWings');
        this.$toast.error('Something went wrong getting your fund tokens', {
          toastClassName: ['toast-std', 'warning-toast'],
        });
      });
    },
    showVisitsHad() {
      return this.prisonerNumber && this.selectedVisitorId && this.selectedBookingSlotDate;
    },
    getVisitsHad(e = null) {
      if (e) {
        this.setBookingSlotDate(e);
      }
      if (!this.showVisitsHad()) {
        return;
      }
      this.loadingVisitsHadOnMonth = true;

      VisitService.getNumberOfVisitsThisMonth(this.prisonerNumber, this.selectedBookingSlotDate).then(res => {
        this.visitsHadThisMonth = res.data.num_of_visits;
        this.loadingVisitsHadOnMonth = false;
      });
    },
    getBookingSlotsWithStockForWing() {
      let wingId = this.wingEnabled ? this.selectedWing._id : '';
      BookingSlotService.getBookingSlotsWithStockForWing(this.prison.prison_id, wingId).then(res => {
        this.bookingSlotsWithStock = res.data;
        /*
          Group days of the week together
          [{day_of_week: string, slots: [{booking_slot_id: string, slot_begin: string, slot_end: string]}
         */
        const flatten = {};
        this.bookingSlotsWithStock.forEach((bookingSlotStock) => {
          if (flatten[bookingSlotStock.day_of_week] === null || flatten[bookingSlotStock.day_of_week] === undefined) {
            flatten[bookingSlotStock.day_of_week] = {day_of_week: bookingSlotStock.day_of_week, slots: []};
          }
          flatten[bookingSlotStock.day_of_week].slots.push({
            booking_slot_id: bookingSlotStock._id,
            name: bookingSlotStock.name,
            slot_begin: bookingSlotStock.slot_begin,
            slot_end: bookingSlotStock.slot_end,
          });
        });
        Object.keys(flatten).map((key) => {
          this.bookingSlotsGrouped.push(flatten[key]);
        });
        // Order the grouped slots
        this.bookingSlotsGrouped.forEach((slot) => {
          slot.slots = slot.slots.sort((bs1, bs2) => {
            // Fake year and day, as we only care about the slot_begin time
            const year = 2000;
            const day = 1;
            const bs1StartTime = getDateOfYearDayAndTime(year, day, bs1.slot_begin);
            const bs2StartTime = getDateOfYearDayAndTime(year, day, bs2.slot_begin);
            return bs1StartTime.getTime() - bs2StartTime.getTime();
          });
        });
        // Sort booking slots so they always show Mon-Sun
        const weekDaySorter = {
          'monday': 1,
          'tuesday': 2,
          'wednesday': 3,
          'thursday': 4,
          'friday': 5,
          'saturday': 6,
          'sunday': 7,
        };
        this.bookingSlotsGrouped = this.bookingSlotsGrouped.sort((bsg1, bsg2) => {
          const bs1Day = bsg1.day_of_week.toLowerCase();
          const bs2Day = bsg2.day_of_week.toLowerCase();
          return weekDaySorter[bs1Day] - weekDaySorter[bs2Day];
        });
      }).catch(err => {
        logger.error('Error getting booking slots with stock', err, null, 'BookVisitWithWing:getBookingSlotsWithStockForWing');
        this.$toast.error('Error getting booking slots', {
          toastClassName: ['toast-std', 'warning-toast'],
        });
      });
    },
    clearDateSelection() {
      // Clear selected date
      this.setBookingSlotDate(null);
      this.bookingSlotDates = [];
      // Update date list
      if (this.selectedBookingSlotId) {
        let dates = [];
        this.bookingSlotsWithStock.forEach((bookingSlotWithStock) => {
          if (bookingSlotWithStock._id === this.selectedBookingSlotId) {
            dates = bookingSlotWithStock.stock;
          }
        });
        // Order dates, closest first
        dates.sort((d1, d2) => {
          return new Date(d2).getTime() - new Date(d1).getTime();
        });
        this.bookingSlotDates = dates;
      }
    },
    resetVisitor() {
      this.$store.commit('booking/SET_VISITOR', null);
      this.selectedVisitorId = null;
      this.setBookingSlotDate(null);
      this.setBookingSlotId(null);
      this.$store.commit('booking/SET_BOOKING_EMAIL', '');
      this.$store.dispatch('booking/resetContact');
    },
    refreshContact() {
      ContactService.getPrisonerOffsiteContacts(this.prisonerNumber).then(res => {
        this.$store.commit('booking/SET_CONTACTS', res.data);
        // replace selected visitor as offsite details have changed
        const existingContact = this.contacts.find(person => person._id === this.visitor._id);
        this.$store.commit('booking/SET_VISITOR', existingContact);
      });
    },
    searchForContacts() {
      this.$store.commit('booking/SET_VISITOR', null);
      this.loadingContacts = true;
      this.resetVisitor();

      if (this.prisonerNumber && this.prisonerNumber.length > 0) {
        ContactService.getPrisonerOffsiteContacts(this.prisonerNumber).then(res => {
          if (!res.data || res.data.length < 1) {
            this.addNewContact(1);
          } else {
            this.$swal('Great news!', `${res.data.length} ${res.data.length <= 1 ? 'contact has' : 'contacts have'} been found. Please select one from the visitor drop down menu.`, 'success');
          }
          this.$store.commit('booking/SET_CONTACTS', res.data);
          this.getVisitsHad();
        }).catch(err => {
          logger.warn('Error getting contacts for Prison or Hospital Number', err, {prisonerNumber: this.prisonerNumber}, 'BookVisit:searchForContacts');
          this.addNewContact(1);
        }).finally(() => {
          this.loadingContacts = false;
        });
      } else {
        this.$toast.info(`Please enter a ${this.$options.filters.term('prisoner')} Number`);
      }
    },
    addNewContact(stageNumber) {
      this.resetVisitor();
      this.$store.dispatch('booking/refreshSites');
      this.$store.commit('booking/SET_OFFSITE_STAGE', stageNumber); // set contact stage to 1
      this.$store.commit('booking/SET_OFFSITE_CONTACT_ITEM', {prop: 'prisoner_number', value: this.prisoner_number}); // set the contacts prisoner number
      this.$refs['modal-contacts'].show();
    },
    selectWing() {
      // Clear booking slot selection
      this.setBookingSlotDate(null);
      this.setBookingSlotId(null);
      // Clear currently loaded booking slots
      this.bookingSlotsGrouped = [];
      // Get stock
      this.getBookingSlotsWithStockForWing();
    },
    selectVisitor(e = null) {
      this.closeModals();
      if (e) {
        this.$store.commit('booking/SET_VISITOR', e);

        if (this.visitor && this.visitor.user && this.visitor.user.user_id) {
          this.selectedVisitorId = this.visitor.user.user_id;
          this.getSelectedVisitorsBan();
          this.setVisitorEstablishment();
        } else {
          this.selectedVisitorId = null;
          this.selectedVisitorBans = [];
          this.loadingSelectedVisitorBans = false;
          this.visitorEstablishment = null;
        }
      }
    },
    setVisitorEstablishment() {
      this.visitorEstablishment = this.establishments.find(item => item.offsite_id === this.visitor.user.offsite_id);
    },
    getSelectedVisitorsBan() {
      this.loadingSelectedVisitorBans = true;

      VisitorService.getVisitorBans(this.selectedVisitorId).then(res => {
        this.selectedVisitorBans = res.data;
        this.loadingSelectedVisitorBans = false;
      }).catch(err => {
        logger.error('Error getting visitor users ban', err, {visitorUserId: this.selectedVisitorId}, 'BookVisitWithWing:getSelectedVisitorsBan');
        this.$toast.error('Error checking if the selected visitor is currently banned. Please refresh the page and try again', {
          toastClassName: ['toast-std', 'warning-toast'],
        });
      });
    },
    isUserBannedOnBookingSlot() {
      if (this.selectedBookingSlotDate) {
        let banned = false;
        const slotDate = moment(this.selectedBookingSlotDate);
        this.selectedVisitorBans.forEach((ban) => {
          const banStartDate = moment(ban.start_date);
          const banEndDate = moment(ban.end_date);
          // Note: the "[]" means inclusive checks on both start and end date
          if (slotDate.isBetween(banStartDate, banEndDate, null, '[]')) {
            banned = true;
          }
        });
        return banned;
      }
      return false;
    },
    isBookValid() {
      if (this.wingEnabled && !this.selectedWing) {
        return false;
      }

      return !(!this.prisonerNumber ||
        !this.visitor ||
        !this.selectedBookingSlotId ||
        !this.selectedBookingSlotDate ||
        this.isUserBannedOnBookingSlot());
    },
    validFundTokens() {
      try {
        const fundTokens = parseInt(this.fundTokens);
        return fundTokens > 0;
      } catch (err) {
        logger.error('Error parsing fund tokens', err, {fundTokensValue: this.fundTokens}, 'BookVisit:validFundTokens');
        return false;
      }
    },
    setBookingVisit(value) {
      this.bookingVisit = value;
    },
    bookAndFundVisit() {
      if (this.checkForAllowedVisitsPerMonth && this.visitsHadThisMonth >= this.allowedVisitsPerMonth) {
        this.$swal({
          title: 'Are you sure you want to book this call?',
          text: `Resident has had ${this.visitsHadThisMonth} calls that month. They are usually only allowed ${this.allowedVisitsPerMonth}. Do you want to continue?`,
          icon: 'warning',
          buttons: true,
          dangerMode: true,
        }).then((willContinue) => {
          if (willContinue) {
            this.sendVisitRequest(true);
            this.fundTokens -= 1;
          }
        });
      } else {
        this.sendVisitRequest(true);
        this.fundTokens -= 1;
      }
    },
    bookVisit() {
      if (this.checkForAllowedVisitsPerMonth && this.visitsHadThisMonth >= this.allowedVisitsPerMonth) {
        this.$swal({
          title: 'Are you sure you want to book this visit?',
          text: `Resident has had ${this.visitsHadThisMonth} visits that month. They are usually only allowed ${this.allowedVisitsPerMonth}. Do you want to continue?`,
          icon: 'warning',
          buttons: true,
          dangerMode: true,
        }).then((willContinue) => {
          if (willContinue) {
            this.sendVisitRequest(false);
          }
        });
      } else {
        this.sendVisitRequest(false);
      }
    },
    checkDuplicateAwaitingVisits() {
      return this.$store.dispatch('booking/checkOverlappingVisitsAwaiting', {
        prisonerNumber: this.prisonerNumber,
        slotId: this.selectedBookingSlotId,
        date: this.selectedBookingSlotDate
      });
    },
    closeModals() {
      this.$refs['modal-contacts'].hide();
    },
    sendVisitRequest(funded) {
      this.checkDuplicateAwaitingVisits().then((duplicate) => {
        if (duplicate) {
          this.$toast.error(`Cannot book visit as ${this.prisonerNumber} is already awaiting confirmation for another visit during the chosen booking slot`, {
            toastClassName: ['toast-std', 'warning-toast'],
          });
        } else {
          if (!this.bookingVisit) {
            let allowChat = false;
            if(this.visitorEstablishment && this.visitorEstablishment.offsite_type === 'School') {
              allowChat = true;
            }
            this.setBookingVisit(true);
            let visitRequestDto = {
              visitor_id: this.selectedVisitorId,
              contact_id: this.visitor._id,
              booked_for_booking_slot_id: this.selectedBookingSlotId,
              booked_for_booking_slot_date: this.selectedBookingSlotDate,
              funded: funded,
              should_record: this.recordVisit || false,
              additional_visitors_ids: [],
              security_band: this.securityBand,
              adult_content_settings: this.adultContentSettings,
              invalid_face_event_action: this.invalidFaceEventAction,
              offsite_id: this.visitor.user.offsite_id,
              booking_email: this.bookingEmail,
              allow_chat_features: allowChat,
              metricAction: 'WebPortalNew',
            };

            if (this.wingEnabled) {
              visitRequestDto.wing_id = this.selectedWing._id;
            }

            if (this.adHocMode) { // add adhoc slot if adhoc mode
              visitRequestDto = {
                ...visitRequestDto,
                ad_hoc_slot: this.$store.state.booking.adHocSlot,
              };
            }

            VisitService.bookOffsiteVisit(visitRequestDto).then(res => {
              this.$toast.success('Visit booked', {
                toastClassName: ['toast-std', 'success-toast'],
              });
              this.$router.push(`/calls/${res.data._id}/details`);
            }).catch(err => {
              logger.error('Error booking visit', err, {dto: visitRequestDto}, 'BookVisitWithWing:sendVisitRequest');
              if (funded) {
                this.fundTokens += 1;
              }

              const error = err && err.response && err.response.data && err.response.data;
              const errorMsg = error ? err.response.data : '';
              let msg = 'Something went wrong booking the visit, please refresh the page and try again';

              if (errorMsg === ERROR_CODES.VISITOR.NOT_VERIFIED) {
                msg = 'Cannot book visit as the visitor is not verified';
              } else if (errorMsg === ERROR_CODES.VISITOR.BANNED_ON_DATE) {
                msg = 'Cannot book visit as visitor is banned on the chosen booking slot';
              } else if (errorMsg === ERROR_CODES.VISIT_STOCK.NONE_LEFT) {
                msg = 'Cannot book visit as the chosen booking slot has no stock left'
              } else if (errorMsg === ERROR_CODES.VISIT.PRISONER_BOOKED_ON_SLOT) {
                msg = `Cannot book visit as ${this.prisonerNumber} is already booked on another visit during the chosen booking slot`;
              } else if (errorMsg === ERROR_CODES.PRISON.NOT_ENOUGH_FUND_TOKENS) {
                msg = 'Unable to fund visit due to a lack of fund tokens.';
              } else if (errorMsg === ERROR_CODES.ADDITIONAL_VISITOR.NOT_VERIFIED) {
                msg = 'Unable to book with those additional visitors as one or more is not marked as verified';
              } else if (errorMsg === ERROR_CODES.WINGS.WING_NOT_PROVIDED) {
                msg = 'Unable to book. Please select a wing.';
              } else if (errorMsg === ERROR_CODES.WINGS.WING_MUST_BE_ENABLED) {
                msg = 'Unable to book. Please refresh your page and select a wing that is enabled.';
              } else if (errorMsg === ERROR_CODES.WINGS.NO_WING_STOCK_LEFT) {
                msg = 'Unable to book. There is no stock left for the wing you have select. Refresh your page and choose a different wing.';
              }

              this.$toast.error(msg, {
                toastClassName: ['toast-std', 'warning-toast'],
              });
            }).finally(() => {
              this.setBookingVisit(false);
            });
          }
        }
      }).catch((err) => {
        logger.error('Error booking offsite visit - checking for duplicates', err, null, 'BookVisitWithWing:sendVisitRequest');
      });
    },
  },
};
</script>
